import { type CSSProperties } from "react"

export type LoadingChartTileKind = "green" | "red" | "grey"

/** Glacial Green stroke strength (0–1). */
const GREEN_TILE_STROKE_OPACITY = 0.35

/** Glacial Red stroke strength (0–1). */
const RED_TILE_STROKE_OPACITY = 0.15

const TILE_FILL = "var(--tessera-loading-tile-fill)"
const GREY_BORDER = "var(--tessera-loading-grey-border)"

export function getLoadingChartTileStyle(
  kind: LoadingChartTileKind,
  variant: "desktop" | "mobile"
): CSSProperties {
  const borderRadius = variant === "desktop" ? "10px" : "6px"
  const borderWidth = variant === "desktop" ? "3px" : "2px"
  const greenO = GREEN_TILE_STROKE_OPACITY
  const redO = RED_TILE_STROKE_OPACITY

  if (kind === "green") {
    return {
      borderRadius,
      border: `${borderWidth} solid transparent`,
      backgroundImage: `linear-gradient(${TILE_FILL}, ${TILE_FILL}), linear-gradient(135deg, rgba(6, 227, 99, ${greenO}), rgba(148, 228, 160, ${greenO}))`,
      backgroundOrigin: "border-box",
      backgroundClip: "padding-box, border-box",
      backgroundColor: "transparent",
      boxSizing: "border-box",
    }
  }

  if (kind === "red") {
    return {
      borderRadius,
      border: `${borderWidth} solid transparent`,
      backgroundImage: `linear-gradient(${TILE_FILL}, ${TILE_FILL}), linear-gradient(135deg, rgba(255, 106, 115, ${redO}), rgba(254, 66, 68, ${redO}))`,
      backgroundOrigin: "border-box",
      backgroundClip: "padding-box, border-box",
      backgroundColor: "transparent",
      boxSizing: "border-box",
    }
  }

  return {
    borderRadius,
    border: `${borderWidth} dashed ${GREY_BORDER}`,
    backgroundColor: "transparent",
    boxSizing: "border-box",
  }
}
